import { useQuery } from '@tanstack/react-query';
import { AnalyticalPanel, DataQualityState, EventTimeline } from '@atlas/ui';
import { api } from '../../lib/api';
import { ExplainActions, PageHeader } from '../../components/shared';
import { PageSkeleton } from '../../components/PageSkeleton';

export function ThesesPage() {
  const { data, isLoading, isError } = useQuery({ queryKey: ['theses'], queryFn: api.theses });

  if (isLoading) return <PageSkeleton blocks={3} />;
  if (isError || !data) return <DataQualityState state="unavailable" title="Thesis ledger unavailable" />;

  const theses = data.theses ?? [];

  return (
    <div className="space-y-6">
      <PageHeader title="Theses" subtitle="Thesis book, falsifiers, and reviews." />
      <ExplainActions screenName="Theses" />

      <AnalyticalPanel title="Timeline ledger">
        {theses.length === 0 ? (
          <DataQualityState state="empty" title="No active theses" />
        ) : (
          <EventTimeline
            events={theses.map((t) => ({
              id: t.thesisId,
              time: t.state,
              title: t.title,
              description: t.summary,
              type: 'decision',
            }))}
          />
        )}
      </AnalyticalPanel>

      <div className="grid gap-4 md:grid-cols-2">
        {theses.map((t) => (
          <AnalyticalPanel key={t.thesisId} title={t.title} eyebrow={t.setupType}>
            <p className="text-sm text-[var(--color-text-secondary)]">{t.summary}</p>
            <div className="mt-3 grid gap-2 text-xs">
              <p>
                <span className="text-[var(--color-positive)]">Catalysts:</span>{' '}
                {t.catalysts?.join('; ') ?? '—'}
              </p>
              <p>
                <span className="text-[var(--color-negative)]">Falsifiers:</span>{' '}
                {t.falsifiers?.join('; ') ?? '—'}
              </p>
            </div>
          </AnalyticalPanel>
        ))}
      </div>
    </div>
  );
}
